jQuery(function () {
    var breakpoint = 1024;
    var scrollTop = 0;
    function addToggleFunction(toggleSectionClass, btnClass) {
        $(btnClass + '.js-toggle-btn').click(function (e) {
            e.preventDefault();
            toggleFunction(toggleSectionClass, $(this));
        });
    }
    function addToggleFunctionWithIgnoredClasses(toggleSectionClass, btnClass, classesToIgnore) {
        $(btnClass + '.js-toggle-btn').click(function (e) {
            if (hasPropagationClass($(e.target), classesToIgnore)) {
                return;
            }
            toggleFunction(toggleSectionClass, $(this));
        });
    }
    function hasPropagationClass($eventTarget, classesToIgnore) {
        for (var i in classesToIgnore) {
            if ($eventTarget.hasClass(classesToIgnore[i])) {
                return true;
            }
        }
        return false;
    }
    function toggleFunction(toggleSectionClass, expandBtn) {
        expandBtn.toggleClass('is-active');
        var toggleSection = expandBtn.siblings(toggleSectionClass);
        if (toggleSection.length === 0) {
            toggleSection = expandBtn.find(toggleSectionClass).first();
        }
        if (expandBtn.hasClass('is-active')) {
            toggleSection.slideDown('1000', function () {
                toggleSection.addClass('is-active');
            });
        }
        else {
            toggleSection.slideUp('1000', function () {
                toggleSection.removeClass('is-active');
            });
        }
    }
    function addDropdownFunction(toggleSectionClass, btnClass) {
        $(btnClass + '.js-toggle-btn').on('click', function () {
            if (window.innerWidth > breakpoint) {
                return;
            }
            var expandBtn = $(this);
            expandBtn.toggleClass('is-active');
            var toggleSection = expandBtn.siblings(toggleSectionClass);
            if (toggleSection.length === 0) {
                toggleSection = expandBtn.find(toggleSectionClass).first();
            }
            if (expandBtn.hasClass('is-active')) {
                toggleSection.addClass('is-active');
                stopBodyScroll(true);
            }
            else {
                toggleSection.removeClass('is-active');
                stopBodyScroll(false);
            }
        });
    }
    function stopBodyScroll(stop) {
        var $body = $('body');
        if (stop) {
            scrollTop = $body.scrollTop();
            $body.addClass('prevent-mobile-scroll');
        }
        else {
            $body.removeClass('prevent-mobile-scroll');
            $body.scrollTop(scrollTop);
        }
    }
    $(document).ready(function () {
        addDropdownFunction('.renovation-phases__column__container', '.renovation-phases');
        addToggleFunction('.renovation-moment-section__container', '.renovation-moment-section__heading');
        addToggleFunctionWithIgnoredClasses('.step-area__step__text', '.step-area__step__heading', ['checkbox__label', 'checkbox__input']);
    });
});
